import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LoaderComponent, ToasterComponent } from 'shared';
import { Component, computed, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { AuthService } from '../core/auth/auth.service';
import { Footer } from '../core/layout/footer/footer';
import { NavComponent } from '../core/layout/nav/nav.component';
import { SideNavComponent } from '../core/layout/side-nav/side-nav.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NavComponent,
    SideNavComponent,
    ToasterComponent,
    Footer,
    LoaderComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private subscription = new Subscription();

  private translate = inject(TranslateService);
  private router = inject(Router);
  public authService = inject(AuthService);

  // Track current URL changes
  private currentUrl = signal(window.location.pathname);

  showItcLogo = computed(() => {
    const url = this.currentUrl();
    const paths = ['/login', '/register', '/forgot-password', '/invitation'];
    return paths.some((path) => url.includes(path));
  });

  ngOnInit() {
    this.initLanguages();

    // Update URL signal on route changes
    this.subscription.add(
      this.router.events.subscribe(() => {
        this.currentUrl.set(window.location.pathname);
      }),
    );
  }

  initLanguages() {
    const supportedLanguages = ['en', 'es', 'fr'];
    this.translate.addLangs(supportedLanguages);
    this.translate.setFallbackLang('en');

    const browserLang = this.translate.getBrowserLang();
    const lang = browserLang && supportedLanguages.includes(browserLang) ? browserLang : 'en';
    this.translate.use(lang);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
